import React, { useRef, useEffect } from 'react';
import { JitsiMeeting } from '@jitsi/react-sdk';

const JitsiContainer = React.memo(({ roomName, userName, role, onIframeRef }) => {
  const uniqueRoomId = `hayaa-academy-${roomName}`;

  return (
    <div className="jitsi-wrapper-custom" style={{ width: '100%', height: '100%' }}>
      <JitsiMeeting
        domain="fairmeeting.net"
        roomName={uniqueRoomId}
        configOverwrite={{
          startWithAudioMuted: role === 'STUDENT', // Bachhe mute rahenge start mein
          startWithVideoMuted: false,
          prejoinPageEnabled: false, // Seedha class mein entry (No pre-join screen)
          prejoinConfig: {
            enabled: false
          },
          disableModeratorIndicator: true,
          // ✅ FIX: Prevents mobile "How do you want to join?" app install prompt
          disableDeepLinking: true,
          requireDisplayName: false,
          enableWelcomePage: false,
          enableClosePage: false
        }}
        interfaceConfigOverwrite={{
          DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
          TOOLBAR_BUTTONS: ['microphone', 'camera', 'desktop', 'fullscreen', 'hangup'],
          MOBILE_APP_PROMO: false
        }}
        userInfo={{
          displayName: userName.split('@')[0] + (role === 'COACH' ? ' (Coach)' : '')
        }}
        getIFrameRef={(iframeRef) => { 
          if (onIframeRef) onIframeRef(iframeRef);
          iframeRef.style.height = '100%'; 
          iframeRef.style.width = '100%'; 
          if (iframeRef.parentNode) {
            iframeRef.parentNode.style.height = '100%';
            iframeRef.parentNode.style.width = '100%';
          }
        }}
      />
    </div>
  );
}, (prevProps, nextProps) => {
  return prevProps.roomName === nextProps.roomName &&
         prevProps.userName === nextProps.userName &&
         prevProps.role === nextProps.role;
});

export default function LiveVideo({ roomName, userName, role, height = '250px' }) {
  const iframeRefVal = useRef(null);

  useEffect(() => {
    if (iframeRefVal.current) {
      iframeRefVal.current.style.height = '100%';
      iframeRefVal.current.style.width = '100%';
      if (iframeRefVal.current.parentNode) {
        iframeRefVal.current.parentNode.style.height = '100%';
        iframeRefVal.current.parentNode.style.width = '100%';
      }
    }
  }, [height]);

  return (
    <div style={{width: '100%', height, borderRadius: '8px', overflow: 'hidden', border: '1px solid rgba(163, 177, 198, 0.4)', position: 'relative' }}>
      <style>{`
        .jitsi-wrapper-custom,
        .jitsi-wrapper-custom > div,
        .jitsi-wrapper-custom iframe {
          width: 100% !important;
          height: 100% !important;
        }
      `}</style>
      <JitsiContainer 
        roomName={roomName} 
        userName={userName} 
        role={role} 
        onIframeRef={(iframe) => {
          iframeRefVal.current = iframe;
        }} 
      />
    </div>
  );
}
